module.exports = __webpack_public_path__ + "img/bg.36018477.png";